import { useEffect, useRef, useState } from 'react';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import {
  ButtonsRow,
  CleanButton,
  Content,
  Header,
  Modal,
  ObservationInfo,
  SaveButton,
  StyledFormGroup,
  StyledSelect,
  TransparentBg,
  ErrorText,
} from './styled';
import { ReactComponent as CloseIcon } from 'assets/icons/close-gray.svg';
import { ReactComponent as CleanIcon } from 'assets/icons/cleanFiltersIcon.svg';
import { Controller, useFormContext } from 'react-hook-form';
import { Textarea } from 'components/Form/subcomponents/Textarea';
import { useMediaQuery } from 'react-responsive';
import { useCookies } from 'react-cookie';
import { GenericTooltip } from 'components/Tooltip/NoIconTooltip';
export const AdvancedDetailModal = ({
  type,
  onSave,
  setOpenAdvancedModal,
  fields,
  fetchData,
  companyConfig,
  loadMoreAreas,
  searchArea,
  loadMoreEquipamentos,
  searchEquipamento,
  setAreaPage,
  setEquipamentoPage,
}) => {
  const { control, getValues, setValue, reset } = useFormContext();
  const [cookie] = useCookies();
  const manualChangeRef = useRef(true);
  const textAreaRef = useRef(null);
  const [errors, setErrors] = useState({});
  const onSubmit = () => {
    const values = getValues();
    const newErrors = {};

    if (companyConfig.grupoAreaObrigatorio && !values.areaGroup) {
      newErrors.areaGroup = 'Grupo de Área é obrigatório.';
    }

    if (companyConfig.subgrupoAreaObrigatorio && !values.areaSubGroup) {
      newErrors.areaSubGroup = 'Subgrupo de Área é obrigatório.';
    }

    if (companyConfig.areaObrigatoria && !values.area) {
      newErrors.area = 'Ambiente é obrigatório.';
    }

    if (companyConfig.equipamentoObrigatorio && type === 'equipamento' && !values.equipment) {
      newErrors.equipment = 'Equipamento é obrigatório.';
    }

    // Se houver erros, atualiza o estado e para a execução
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    onSave(getValues());
    setOpenAdvancedModal(false);
  };
  const cleanFilters = () => {
    setValue('area', '', { shouldDirty: true });
    setValue('equipment', '', { shouldDirty: true });
    setValue('observation', '', { shouldDirty: true });
    setValue('areaGroup', '', { shouldDirty: true });
    setValue('areaSubGroup', '', { shouldDirty: true });
    fetchData();
  };
  const isDesktop = useMediaQuery({ minWidth: 1081 });
  useEffect(() => {
    if (!cookie?.qrcodeFilters) return;
    switch (cookie?.qrcodeFilters?.type) {
      case 'A':
        reset({
          ...getValues(),
          ...{
            areaGroup: cookie?.qrcodeFilters?.newChamado?.grupoArea,
            areaSubGroup: cookie?.qrcodeFilters?.newChamado?.subGrupoArea,
            area: cookie?.qrcodeFilters?.newChamado?.area,
            receiveEmail: true,
            whatsappContact: true,
          },
        });

        break;

      case 'E':
        reset({
          ...getValues(),
          ...{
            areaGroup: cookie?.qrcodeFilters?.newChamado?.grupoArea,
            areaSubGroup: cookie?.qrcodeFilters?.newChamado?.subGrupoArea,
            area: cookie?.qrcodeFilters?.newChamado?.area,
            equipment: cookie?.qrcodeFilters?.equipamento?.valueNumber,
            receiveEmail: true,
            whatsappContact: true,
          },
        });
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);
  const autoFillInput = (value, name) => {
    const array = fields?.local?.[name] || [];
    const firstMatch = array.find(i => i.value === value) || {};
    const updates = {
      area: {
        areaGroup: firstMatch.grupoAreaId ?? null,
        areaSubGroup: firstMatch.subgrupoAreaId ?? null,
        //area: firstMatch.area ?? null,
      },
      equipment: {
        area: firstMatch.area ?? null,
        areaGroup: firstMatch.grupoAreaId ?? null,
        areaSubGroup: firstMatch.subgrupoAreaId ?? null,
      },
    };
    if (name === 'equipment' && firstMatch.area && fields?.local?.area) {
      const areaExists = fields.local.area.some(a => a.value === firstMatch.area);

      if (!areaExists) {
        fields.local.area = [
          {
            label: firstMatch.areaNome,
            value: firstMatch.area,
          },
          ...fields.local.area,
        ];
      }
    }
    if (updates[name]) {
      manualChangeRef.current = false;
      reset(
        {
          ...getValues(),
          ...updates[name],
        },
        { keepDirty: true },
      );
    }
  };
  useEffect(() => {
    manualChangeRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues().areaGroup, getValues().areaSubGroup]);
  return (
    <TransparentBg>
      <Modal>
        <Header>
          Detalhamento Avançado (opcional) <CloseIcon onClick={() => setOpenAdvancedModal(false)} />
        </Header>
        <Content>
          <FieldRow marginBottom={isDesktop ? '36px' : '20px'} />
          <StyledFormGroup
            label="Grupo de Ambientes"
            width={isDesktop ? '569px' : '299px'}
            isRequired={companyConfig.grupoAreaObrigatorio}
          >
            <Controller
              name="areaGroup"
              defaultValue={''}
              control={control}
              rules={{ required: 'Preenchimento obrigatório.' }}
              render={props => (
                <>
                  <StyledSelect
                    {...props}
                    disabled={fields?.local?.areaGroup?.length === 0}
                    options={fields?.local?.areaGroup}
                    onChange={value => {
                      if (manualChangeRef.current) {
                        cleanFilters();
                      }
                      props.onChange(value);
                      fetchData();
                    }}
                    placeholder={fields?.local?.areaGroup?.length === 0 ? 'Não há itens para selecionar' : 'Selecionar'}
                  />
                  {fields?.local?.areaGroup?.length === 0 && (
                    <GenericTooltip
                      text={'Não há itens para selecionar'}
                      bottom={isDesktop ? '56px' : '68px'}
                      left={isDesktop ? '375px' : '105px'}
                      afterTop={'26px'}
                      afterLeft={'117px'}
                      width={'235px'}
                      height={'36px'}
                      fontSize={'16px'}
                      textAlign={'center'}
                      lineHeight={'20px'}
                      containerLeft={'0px'}
                      containerTop={'40px'}
                      containerHeight={'48px'}
                    />
                  )}
                </>
              )}
            />

            {errors.areaGroup && <ErrorText>{errors.areaGroup}</ErrorText>}
          </StyledFormGroup>
          <FieldRow marginBottom={isDesktop ? '36px' : '20px'} />
          <StyledFormGroup
            label="Subgrupo de Ambientes"
            width={isDesktop ? '569px' : '299px'}
            isRequired={companyConfig.subgrupoAreaObrigatorio}
          >
            <Controller
              name="areaSubGroup"
              defaultValue={''}
              control={control}
              rules={{ required: 'Preenchimento obrigatório.' }}
              render={props => (
                <>
                  <StyledSelect
                    {...props}
                    options={fields?.local?.areaSubGroups}
                    disabled={fields?.local?.areaSubGroup?.length === 0}
                    onChange={value => {
                      if (manualChangeRef.current) {
                        setValue('area', '', { shouldDirty: true });
                        setValue('equipment', '', { shouldDirty: true });
                        setValue('observation', '', { shouldDirty: true });
                      }
                      props.onChange(value);
                      fetchData();
                    }}
                    placeholder={
                      fields?.local?.areaSubGroup?.length === 0 ? 'Não há itens para selecionar' : 'Selecionar'
                    }
                  />
                  {fields?.local?.areaSubGroup?.length === 0 && (
                    <GenericTooltip
                      text={'Não há itens para selecionar'}
                      bottom={isDesktop ? '56px' : '68px'}
                      left={isDesktop ? '375px' : '105px'}
                      afterTop={'26px'}
                      afterLeft={'117px'}
                      width={'235px'}
                      height={'36px'}
                      fontSize={'16px'}
                      textAlign={'center'}
                      lineHeight={'20px'}
                      containerLeft={'0px'}
                      containerTop={'40px'}
                      containerHeight={'48px'}
                    />
                  )}
                </>
              )}
            />

            {errors.areaSubGroup && <ErrorText>{errors.areaSubGroup}</ErrorText>}
          </StyledFormGroup>
          <FieldRow marginBottom={isDesktop ? '36px' : '20px'} />
          <StyledFormGroup
            label="Ambiente"
            width={isDesktop ? '569px' : '299px'}
            isRequired={companyConfig.areaObrigatoria}
          >
            <Controller
              name="area"
              defaultValue={''}
              control={control}
              rules={{ required: 'Preenchimento obrigatório.' }}
              render={props => (
                <>
                  <StyledSelect
                    {...props}
                    options={fields?.local?.area}
                    disabled={fields?.local?.area?.length === 0}
                    searchMode="remote"
                    dataMode="infinite"
                    onScrollEnd={loadMoreAreas}
                    onSearch={searchArea}
                    onChange={value => {
                      if (manualChangeRef.current) {
                        setValue('equipment', '', { shouldDirty: true });
                        setValue('observation', '', { shouldDirty: true });
                      }
                      props.onChange(value);
                      setAreaPage(1);
                      fetchData();
                      autoFillInput(value, props.name);
                    }}
                    placeholder={fields?.local?.area?.length === 0 ? 'Não há itens para selecionar' : 'Selecionar'}
                  />
                  {fields?.local?.area?.length === 0 && (
                    <GenericTooltip
                      text={'Não há itens para selecionar'}
                      bottom={isDesktop ? '56px' : '68px'}
                      left={isDesktop ? '375px' : '105px'}
                      afterTop={'26px'}
                      afterLeft={'117px'}
                      width={'235px'}
                      height={'36px'}
                      fontSize={'16px'}
                      textAlign={'center'}
                      lineHeight={'20px'}
                      containerLeft={'0px'}
                      containerTop={'40px'}
                      containerHeight={'48px'}
                    />
                  )}
                </>
              )}
            />

            {errors.area && <ErrorText>{errors.area}</ErrorText>}
          </StyledFormGroup>
          <FieldRow marginBottom={isDesktop ? '36px' : '20px'} />
          <StyledFormGroup label="Observação">
            <ObservationInfo>
              Insira uma explicação do local, caso não tenha encontrado nas opções anteriores.
            </ObservationInfo>
            <Controller
              name="observation"
              defaultValue={''}
              control={control}
              render={props => (
                <Textarea
                  {...props}
                  ref={textAreaRef}
                  placeholder={'Escreva aqui (opcional)'}
                  width={'100%'}
                  size={'custom'}
                  customStyle={{
                    padding: '12px',
                    resize: 'none',
                    overflow: 'scroll',
                    height: '80px',
                  }}
                />
              )}
            />
          </StyledFormGroup>
          <FieldRow marginBottom={isDesktop ? '36px' : '20px'} />
          {type === 'equipamento' && (
            <>
              <StyledFormGroup
                label="Equipamento"
                width={isDesktop ? '569px' : '299px'}
                isRequired={companyConfig.equipamentoObrigatorio}
              >
                <Controller
                  name="equipment"
                  defaultValue={cookie?.qrcodeFilters?.equipamentos?.valueNumber || ''}
                  control={control}
                  rules={{ required: 'Preenchimento obrigatório.' }}
                  render={props => (
                    <>
                      <StyledSelect
                        {...props}
                        disabled={fields?.local?.equipment?.length === 0}
                        value={props.value}
                        options={fields?.local?.equipment}
                        searchMode="remote"
                        dataMode="infinite"
                        onScrollEnd={loadMoreEquipamentos}
                        onSearch={searchEquipamento}
                        onChange={value => {
                          props.onChange(value);
                          setAreaPage(1);
                          setEquipamentoPage(1);
                          autoFillInput(value, props.name);
                        }}
                        placeholder={
                          fields?.local?.equipment?.length === 0 ? 'Não há itens para selecionar' : 'Selecionar'
                        }
                      />
                      {fields?.local?.equipment?.length === 0 && (
                        <GenericTooltip
                          text={'Não há itens para selecionar'}
                          bottom={isDesktop ? '56px' : '68px'}
                          left={isDesktop ? '375px' : '105px'}
                          afterTop={'26px'}
                          afterLeft={'117px'}
                          width={'235px'}
                          height={'36px'}
                          fontSize={'16px'}
                          textAlign={'center'}
                          lineHeight={'20px'}
                          containerLeft={'0px'}
                          containerTop={'40px'}
                          containerHeight={'48px'}
                        />
                      )}
                    </>
                  )}
                />

                {errors.equipment && <ErrorText>{errors.equipment}</ErrorText>}
              </StyledFormGroup>
              <FieldRow marginBottom={isDesktop ? '36px' : '20px'} />
            </>
          )}
          <ButtonsRow>
            <SaveButton onClick={onSubmit}>SALVAR</SaveButton>
            <CleanButton onClick={() => cleanFilters()}>
              <CleanIcon />
              LIMPAR CAMPOS
            </CleanButton>
          </ButtonsRow>
        </Content>
      </Modal>
    </TransparentBg>
  );
};
